import { t } from "i18next";
import { useEffect, useState } from "react";
import { currentTutorSchedules } from "../../../../api/endpoints/tutors/schedules";
import { indexTutorSchedulesSlot } from "../../../../api/endpoints/tutors/scheduleSlots";
import ApiDateParser from "../../../../helpers/parsers/apiDateParser";
import FreeTimeSchedule from "../../FreeTimeSchedule";
import RequestChangeAppointmentModal from "../../../../components/modal/RequestChangeAppointment";
import { Schedule, Slot } from "../../../../api/@types/scheduleTypes";
import { createProposedAvailability } from "../../../../api/endpoints/tutors/proposedSchedules";
import { ErrorService } from "../../../../services/errorService";
import ChangeTutorStudentAppointmentsModal from "../../../../components/modal/views/ChangeTutorStudentAppointments";
import ActiveRequestGroupModel from "../../../../api/models/ActiveRequestGroupModel";
import { useNavigate } from "react-router-dom";

export default function UpdateWeeklySchedule() {
  const [scheduleSlots, setScheduleSlots] = useState<any>([]);
  const [_, setSchedulesId] = useState<any>(null);
  const [scheduleSlotsMap, setScheduleSlotsMap] = useState<any>({});
  const [removedScheduleSlot, setRemovedScheduleSlot] = useState<any>([]);
  const [activeRequest, setActiveRequest] = useState<ActiveRequestGroupModel>();
  const navigate = useNavigate();
  const [showChangeScheduleWarningModal, setShowChangeScheduleWarningModal] =
    useState(false);
  const [showStudentModal, setShowStudentModal] = useState(false);

  useEffect(() => {
    getTutorSchedules();
    getTutorSchedulesId();
  }, []);

  useEffect(() => {
    let currentScheduleMap: any = {};
    if (!!scheduleSlots && scheduleSlots.length > 0) {
      scheduleSlots.forEach((slot: any) => {
        if (!currentScheduleMap[slot.day_of_the_week])
          currentScheduleMap[slot.day_of_the_week] = [];
        const parsedSlot = {
          id: slot.id,
          startTime: ApiDateParser.parse(slot.start_time),
          endTime: ApiDateParser.parse(slot.end_time),
        };
        currentScheduleMap[slot.day_of_the_week].push(parsedSlot);
      });
      setScheduleSlotsMap(currentScheduleMap);
    }
  }, [scheduleSlots]);

  const getTutorSchedules = async () => {
    try {
      const Data: any = await indexTutorSchedulesSlot();
      setScheduleSlots(Data.data);
    } catch (error) {}
  };

  const getTutorSchedulesId = async () => {
    try {
      const { data }: any = await currentTutorSchedules();
      // updateTutorSchedule;
      if (!!data && !Array.isArray(data) && data.id) setSchedulesId(data.id);
    } catch (error) {}
  };

  const onSaveTutorSchedules = async (data: Schedule) => {
    onConfirmProposedScheduleSlots(data?.schedule_slots_attributes || []);
  };

  const onConfirmProposedScheduleSlots = async (data: Slot[]) => {
    const newSlots: Slot[] =
    data?.filter((slot: Slot) => !slot?._destroy) || [];
    const newSchedule: Schedule = { schedule_slots_attributes: newSlots };
    const response = await createProposedAvailability(newSchedule);
    if (response.isSuccess) {
      const request = new ActiveRequestGroupModel(response.data);
      setActiveRequest(request);
      setShowChangeScheduleWarningModal(false);

      if (!!request && request?.remianing_students?.length != 0) {
         setShowChangeScheduleWarningModal(true);
      
      } else {
        navigate("/tutor/dashboard/weekly-schedule");
      }
    } else {
      ErrorService.handleApiErrors(response);
    }
  };

  const RemoveTutorScheduleSlot = (slot: any) => {
    setRemovedScheduleSlot((oldArray: any) => [...oldArray, slot]);
  };
  const handelOnConfirmRequestChangeAppointmentModal = () => {
    setShowChangeScheduleWarningModal(false);
    setShowStudentModal(true);
  }
  return (
    <>
      <FreeTimeSchedule
        onSaveSlots={onSaveTutorSchedules}
        onRemoveSlot={RemoveTutorScheduleSlot}
        scheduleSlot={scheduleSlotsMap}
        removedScheduleSlot={removedScheduleSlot}
        isEdit={true}
        submitButtonText={t(`page.freeTime.save`)}
        showChangeLanguage={false}
        containerStyles="w-full px-5"
      />
      <RequestChangeAppointmentModal
        onConfirm={handelOnConfirmRequestChangeAppointmentModal}
        onClose={() => setShowChangeScheduleWarningModal(false)}
        isOpen={showChangeScheduleWarningModal}
      />
      {!!activeRequest && (
        <ChangeTutorStudentAppointmentsModal
          activeRequest={activeRequest}
          setActiveRequest={setActiveRequest}
          open={showStudentModal}
          setOpen={setShowStudentModal}
        />
      )}
    </>
  );
}
